module.exports = __webpack_public_path__ + "img/newsletter6.b0420f6d.jpeg";